import { colors } from '../../shared/styles';

export const styles = {
  sponsorsContainer: (isMobile) => ({
    padding: isMobile ? '10px' : '15px',
    backgroundColor: colors.white,
    boxShadow: colors.cardShadow,
  }),
  label: {
    marginBottom: 20,
    fontSize: 18,
    color: colors.textColor
  },
  interiorContainer: {
    textAlign: 'center'
  }
};



/** WEBPACK FOOTER **
 ** ./components/sponsors/styles.js
 **/